// src/components/AddToCartButton/AddToCartButton.js
import React from 'react';
import './BuyNowButton.css';
import {useNavigate} from "react-router-dom";

export default function BuyNowButton({
                                            productId,
                                            priceParams = {},
                                            userData = null,
                                            onSuccess,
                                            children = 'Купити зараз'
                                        }) {
    const navigate = useNavigate();
    // URL вашої Lambda, де POST /cart/add
    const LAMBDA_URL = 'https://thskp6o2fa52da7h27qkh6ndw40hfban.lambda-url.eu-west-2.on.aws';

    const handleClick = async () => {
        if (!productId) {
            alert('Missing productId');
            return;
        }

        onSuccess = () => navigate('/checkout');

        // Якщо користувач авторизований => викликаємо /cart/add
        if (userData?.token) {
            try {
                const res = await fetch(`${LAMBDA_URL}/add`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userData.token}`
                    },
                    body: JSON.stringify({
                        productId,
                        priceParams
                    })
                });
                const data = await res.json();
                if (!res.ok) {
                    throw new Error(data.message || 'Add to cart failed');
                }

                console.log('Add to cart success:', data);
                // Викликаємо відкриття модалки
                if (onSuccess) {
                    onSuccess();
                }
            } catch (err) {
                console.error('Add to cart error:', err);
                alert('Could not add item to cart: ' + err.message);
            }
        } else {
            // Неавторизований => логіка локального кошика або повідомлення
            alert('You are not logged in! Implement local cart or prompt login.');
            // За бажанням відкриваємо локальну модалку
            if (onSuccess) {
                onSuccess();
            }
        }
    };

    return (
        <button className="buy-now-btn" onClick={handleClick}>
            {children}
        </button>
    );
}
